import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router';
import routes from './src/routes';
import $ from 'jquery';
import { ErrorBoundary } from 'react-error-boundary';
import history from './src/history';
import store from './src/store';
import getUrlInfo from './src/services/mini/getUrlInfo';
import * as projectsActionTypes from './src/redux/projects/actionTypes.projects';
import getPageTitle from './src/services/mini/getPageTitle';
import ToasterService from './src/services/ToasterService';
import PopupService from './src/services/PopupService';
import { ErrorFallback } from './src/views/components/ErrorFallback/ErrorFallback';
import errorHandler from './src/errorHandlerUtility';
import * as actions from './src/redux/user/actions.user';
import * as configActions from './src/redux/config/actions.config';
import './src/scss/main.scss';
import './src/utils/graphGlobalFunctions';
import isLocalStorageAvailable from './src/services/mini/isLocalStorageAvailable';
import device from './src/services/mini/device';
import { MarkdownStyle } from './src/views/containers/MarkdownStyle';
import { connectAlanTutor } from './src/api/helpers/connectAlanTutor';

PopupService.init();

window.$ = window.jQuery = $;
require('highlight-within-textarea');

const myErrorHandler = (error, componentStack) => {
    console.info('ALAN ERROR', error, componentStack);
    console.error(error);
    errorHandler.report(error);
};

let providerClass = 'provider-container';
let newVersion = null;
let currentVersion = process.env.VERSION;


if (!window.tutor) {
    connectAlanTutor().catch(status => {
        console.info('Connection status is:', status);
    });
}

if (!device.isDesktop()) {
    document.documentElement.className = 'mobile';
}

if (device.isFirefox()) {
    document.body.classList.add('ff');
}

window.$ = $;
window.debugInfo = { 'web version': process.env.VERSION };
window.alanPublicApi = {};


const urlInfo = getUrlInfo();

if (urlInfo.projectName) {
    document.title = getPageTitle(urlInfo.projectName);
}

if (isLocalStorageAvailable() && window.location.search.indexOf('utm_campaign') > -1) {
    window.localStorage.setItem('params', window.location.search);
}

window.alanStudio = {
    debug: {
        callApi: function (apiName, params, cb) {
            if (window.tutor) {
                window.tutor.call(apiName, params || {}, function (e, res) {
                    if (res) {
                        console.log(`${apiName} result: `, res);
                    }
                    if (e) {
                        console.error(`Error in ${apiName}: `, e);
                    }
                    if (cb) {
                        cb(e, res);
                    }
                });
            }
        }
    }
};

store.dispatch(configActions.getFeaturesConfig());

window.alanUi.tabActive = true;
window.onfocus = function () {
    document.body.classList.remove('with-ctrl');
    window.alanUi.tabActive = true;
    store.dispatch(actions.getGithubPromoInfo());
    if (process.env.NODE_ENV === 'production') {
        $.get(`/web/version.json?=${Date.now()}`).then((data) => {
            console.info('VERSION CHECK:', data, currentVersion);
            if (data.version !== currentVersion && data.version !== newVersion) {
                ToasterService.showInfo({
                    title: 'New version of the Alan AI Studio is available. ' +
                        '<a id="ok">Reload</a>',
                    okAction: function () {
                        window.location.reload();
                    },
                    onlyUserCanHide: true
                });
                newVersion = data.version;
            }
        });
    }
};

window.onblur = function () {
    window.alanUi.tabActive = false;
};

document.addEventListener('keydown', (e) => {
    if (e.ctrlKey || e.metaKey) {
        document.body.classList.add('with-ctrl');
    }
});

document.addEventListener('keyup', function (event) {
    if (!event.ctrlKey && !event.metaKey) {
        document.body.classList.remove('with-ctrl');
    }
});



ReactDOM.render(
    <div className={providerClass}>
        <ErrorBoundary FallbackComponent={ErrorFallback} onError={myErrorHandler}>
            <MarkdownStyle />
            <Provider store={store}>
                <Router history={history} routes={routes} />
            </Provider>
        </ErrorBoundary>
    </div>, document.getElementById('container'));